function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


import classNames from 'classnames';
import React from 'react';
const styles = require('./Spinner-styles.module.scss');
export default function Spinner({
  className,
  size = 'auto',
  ...props
}) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    className: classNames(className, styles.container, size && styles[size])
  }, props), React.createElement("g", {
    fill: "none"
  }, React.createElement("g", {
    transform: "translate(-3, 0)"
  }, React.createElement("g", {
    transform: "translate(2, 2)"
  }, React.createElement("g", {
    className: styles.outerCircle
  }, React.createElement("path", {
    d: "M30,15 C30,6.71572875 23.2842712,0 15,0 C6.71572875,0 2.55795385e-13,6.71572875 2.55795385e-13,15"
  })), React.createElement("g", {
    className: styles.innerCircle
  }, React.createElement("path", {
    d: "M12,0 C5.372583,0 -1.77635684e-15,5.372583 -1.77635684e-15,12"
  }))))));
}